import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-tcpa-additional-loan-modal',
  imports: [MatIconModule, MatProgressSpinnerModule, TranslocoDirective, BaseModalComponent],
  templateUrl: './tcpa-additional-loan-modal.component.html',
  styleUrl: './tcpa-additional-loan-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcpaAdditionalLoanModalComponent {
  isOpen = input<boolean>(false);

  currentLoanNumber = input<number>(1);

  totalLoans = input<number>(1);

  isLoading = input<boolean>(false);

  continue = output<void>();

  exit = output<void>();

  protected readonly remainingLoans = computed(() => this.totalLoans() - this.currentLoanNumber());

  protected onContinue(): void {
    if (!this.isLoading()) {
      this.continue.emit();
    }
  }

  protected onExit(): void {
    if (!this.isLoading()) {
      this.exit.emit();
    }
  }

  protected onClose(): void {
    if (!this.isLoading()) {
      this.exit.emit();
    }
  }
}
